import React, { useEffect, useState, useMemo } from 'react';
import { Box } from '@mui/material';
import { LAYOUT } from './config/layout';
import { getHomeData } from './config/homeData';
import { usePagedScroll } from './hooks/usePagedScroll';
import HomeSlide from './HomeSlide';

const LOCALSTORAGE_KEYS_TO_CLEAR = [
  "sac_hash_step3",
  "sac_step2_data",
  "sac_step5_data",
  "sac_temas_generados",
  "seleccionPaso1",
  "seleccionPaso2",
  "seleccionPaso2_key",
  "seleccionPaso3",
  "sesionesPaso3",
  "sesionesPaso3_key",
  "temasPaso3",
  "temasPaso3_key",
  "ultimoMongoId",
];

export default function Home({ role }) {
  /* =========
     LIMPIEZA DE LOCALSTORAGE
  ========= */
  useEffect(() => {
    LOCALSTORAGE_KEYS_TO_CLEAR.forEach((key) => {
      localStorage.removeItem(key);
    });
  }, []);

  /* =========
     DATA DINÁMICO POR ROL
  ========= */
  const data = useMemo(() => getHomeData(role), [role]);

  /* =========
     ESTADOS BASE
  ========= */
  const [hoveredIndex, setHoveredIndex] = useState(null);

  /* =========
     SCROLL PAGINADO
  ========= */

  const { containerRef, goTo } = usePagedScroll(data.length);



  return (
    <Box
      ref={containerRef}
      sx={{
        height: `calc(100dvh - ${LAYOUT.APPBAR_HEIGHT}px)`,
        overflowY: 'auto',
        overflowX: 'hidden',
        bgcolor: 'grey.50',
        backgroundImage:
          'linear-gradient(180deg, #ffffff 0%, #f6f7fb 100%)',
        borderTop: '6px solid',
        borderColor: 'primary.main',
        position: 'relative',
        scrollSnapType: {
          xs: 'y proximity',
          md: 'y mandatory',
        },
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      <Box sx={{ height: '100%' }}>
        {data.map((item, index) => {
          const nextItem = data[index + 1];

          return (
            <HomeSlide
              key={item.title}
              item={item}
              nextItem={nextItem}   
              index={index}
              total={data.length}
              goTo={goTo}
              hoveredIndex={hoveredIndex}
              setHoveredIndex={setHoveredIndex}
              appBarHeight={LAYOUT.APPBAR_HEIGHT}
            />
          );
        })}


      </Box>
    </Box>
  );
}
